<template>
  <mf-button text :loading="loading" :label="getButtonLabel" color="branco" @click="goToSelectClients" />
</template>

<script>
import { formattedRedirectAfterLogin } from '@/helpers/login'

export default {
  props: {
    buttonLabel: String,
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    isMultiUser() {
      return this.$getIsMultiUser()
    },
    getButtonLabel() {
      return this.buttonLabel || this.$getLoggedUser().client
    },
  },
  methods: {
    async goToSelectClients() {
      this.loading = true
      const singleLoginURL = this.$microservicesUrls['mfLogin']
      const host = location.href.slice(0, location.href.indexOf('#'))
      let hash = this.$route.fullPath
      if (hash[hash.length - 1] === '/') {
        hash = hash.slice(0, -1)
      }
      let metaRedirectAfterLogin = this.$router.currentRoute.meta.redirectAfterLogin
      if (metaRedirectAfterLogin) hash = metaRedirectAfterLogin
      if (hash === '/expired-session') hash = '/home'
      this.$logout()
      window.location.href = formattedRedirectAfterLogin(singleLoginURL, host, hash)
    },
  },
}
</script>
